import{toSignatureHash}from"./toSignatureHash.js";export const toEventSelector=toSignatureHash;